import { Connection, PublicKey, Transaction } from '@solana/web3.js';
import { 
  createTransferInstruction, 
  getAssociatedTokenAddress,
  TOKEN_PROGRAM_ID 
} from '@solana/spl-token';

const TOKEN_MINT = 'E6tBfgKTVCZ3ziP2ZB5V1acDZu6mwA6Ho4jVPVg3pump';
const TOKEN_DECIMALS = 9;

/**
 * Create a token transfer transaction for skin purchase
 */
export const createPurchaseTransaction = async (
  connection,
  buyerPublicKey,
  treasuryWallet,
  amount,
  decimals = TOKEN_DECIMALS
) => {
  try {
    const mintPubkey = new PublicKey(TOKEN_MINT);
    const treasuryPubkey = new PublicKey(treasuryWallet);
    
    // Get associated token accounts
    const buyerTokenAccount = await getAssociatedTokenAddress(
      mintPubkey,
      buyerPublicKey
    );
    
    const treasuryTokenAccount = await getAssociatedTokenAddress(
      mintPubkey,
      treasuryPubkey
    );
    
    // Convert amount to token units (multiply by 10^decimals)
    const tokenAmount = BigInt(Math.floor(amount * Math.pow(10, decimals)));
    
    // Create transfer instruction
    const transferInstruction = createTransferInstruction(
      buyerTokenAccount,
      treasuryTokenAccount,
      buyerPublicKey,
      tokenAmount,
      [],
      TOKEN_PROGRAM_ID
    );
    
    // Create transaction
    const transaction = new Transaction();
    
    // Get recent blockhash
    const { blockhash, lastValidBlockHeight } = await connection.getLatestBlockhash();
    transaction.recentBlockhash = blockhash;
    transaction.lastValidBlockHeight = lastValidBlockHeight;
    transaction.feePayer = buyerPublicKey;
    
    transaction.add(transferInstruction);
    
    return transaction;
  } catch (error) {
    console.error('Error creating purchase transaction:', error);
    throw error;
  }
};

/**
 * Send and confirm a signed transaction
 */
export const sendAndConfirmTransaction = async (connection, signedTransaction) => {
  try {
    const signature = await connection.sendRawTransaction(signedTransaction.serialize());
    
    // Wait for confirmation
    const confirmation = await connection.confirmTransaction(signature, 'confirmed');
    
    if (confirmation.value.err) {
      throw new Error('Transaction failed');
    }
    
    return signature;
  } catch (error) {
    console.error('Error sending transaction:', error);
    throw error;
  }
};

/**
 * Get token balance for a wallet
 */
export const getTokenBalance = async (connection, walletPublicKey) => {
  try {
    const mintPubkey = new PublicKey(TOKEN_MINT);
    const tokenAccount = await getAssociatedTokenAddress(
      mintPubkey,
      walletPublicKey
    );
    
    const balance = await connection.getTokenAccountBalance(tokenAccount);
    return balance.value.uiAmount || 0;
  } catch (error) {
    console.error('Error getting token balance:', error);
    return 0;
  }
};

export default {
  createPurchaseTransaction,
  sendAndConfirmTransaction,
  getTokenBalance,
  TOKEN_MINT,
  TOKEN_DECIMALS
};
